module.exports = __webpack_public_path__ + "img/mute.37a32710.svg";